/* CM · Botón de accesibilidad propio (22-oct-2026). Sin dependencias externas. */
(function(){
  if (window.cmA11y) return; window.cmA11y = 1;
  var KEY = 'cm-a11y', root = document.documentElement, st = {};
  try { st = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { st = {}; }
  var OPTS = [
    ['t', 'Agrandar texto', 'Tamaño del texto: normal, grande o muy grande'],
    ['con', 'Alto contraste', ''],
    ['lnk', 'Subrayar enlaces', ''],
    ['font', 'Fuente legible', ''],
    ['gray', 'Escala de grises', ''],
    ['stop', 'Pausar animaciones', '']
  ];
  function apply() {
    root.classList.remove('a11y-t1', 'a11y-t2');
    if (st.t === 1) root.classList.add('a11y-t1');
    if (st.t === 2) root.classList.add('a11y-t2');
    ['con', 'lnk', 'font', 'gray', 'stop'].forEach(function (k) { root.classList.toggle('a11y-' + k, !!st[k]); });
    if (st.stop) document.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
    try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {}
    if (panel) OPTS.forEach(function (o) {
      var b = panel.querySelector('[data-k="' + o[0] + '"]'); if (!b) return;
      var on = o[0] === 't' ? st.t > 0 : !!st[o[0]];
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (o[0] === 't') b.querySelector('small').textContent = ['Normal', 'Grande', 'Muy grande'][st.t || 0];
    });
  }
  var btn, panel, last;

  /* Sube el botón si un elemento fijo (barra de compra, banners) ocupa la esquina inferior izquierda */
  var wrap, base = 16, tick;
  function fixedAncestor(el) { while (el && el !== document.body) { var p = getComputedStyle(el).position; if (p === 'fixed' || p === 'sticky') return el; el = el.parentElement; } return null; }
  function reposition() {
    if (!wrap) return; var H = window.innerHeight, y = base;
    btn.style.visibility = 'hidden';
    [[22, H - 22], [70, H - 22], [22, H - 70]].forEach(function (pt) {
      document.elementsFromPoint(pt[0], pt[1]).some(function (el) {
        if (wrap.contains(el)) return false;
        var f = fixedAncestor(el); if (!f) return false;
        var r = f.getBoundingClientRect(); if (r.height > H * 0.6) return false;
        y = Math.max(y, Math.round(H - r.top + 12)); return true;
      });
    });
    btn.style.visibility = '';
    wrap.style.setProperty('--cm-a11y-y', y + 'px');
  }
  function schedule() { clearTimeout(tick); tick = setTimeout(reposition, 120); }
  function build() {
    var w = document.createElement('div'); w.id = 'cm-a11y';
    w.innerHTML = '<button type="button" class="cm-a11y-btn" aria-label="Accesibilidad" aria-haspopup="dialog" aria-expanded="false" aria-controls="cm-a11y-panel">' +
      '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><circle cx="12" cy="4.2" r="2.1" fill="currentColor"/><path d="M4 7.6c2.6.8 5.3 1.2 8 1.2s5.4-.4 8-1.2l.5 1.8c-2 .6-4.1 1-6.2 1.2v3.3l2.2 7.4-1.8.6L12.5 15h-1l-2.2 6.9-1.8-.6 2.2-7.4v-3.3c-2.1-.2-4.2-.6-6.2-1.2z" fill="currentColor"/></svg></button>' +
      '<div id="cm-a11y-panel" class="cm-a11y-panel" role="dialog" aria-modal="true" aria-labelledby="cm-a11y-title" hidden>' +
      '<div class="cm-a11y-head"><p id="cm-a11y-title">Accesibilidad</p><button type="button" class="cm-a11y-x" aria-label="Cerrar">&times;</button></div>' +
      '<div class="cm-a11y-grid">' + OPTS.map(function (o) {
        return '<button type="button" data-k="' + o[0] + '" aria-pressed="false"' + (o[2] ? ' aria-describedby="cm-a11y-d-' + o[0] + '"' : '') + '><span>' + o[1] + '</span>' + (o[0] === 't' ? '<small id="cm-a11y-d-t">Normal</small>' : '') + '</button>';
      }).join('') + '</div><button type="button" class="cm-a11y-reset">Restablecer</button></div>';
    document.body.appendChild(w); wrap = w;
    btn = w.querySelector('.cm-a11y-btn'); panel = w.querySelector('.cm-a11y-panel');
    btn.addEventListener('click', function () { panel.hidden ? open() : close(); });
    w.querySelector('.cm-a11y-x').addEventListener('click', close);
    w.querySelector('.cm-a11y-reset').addEventListener('click', function () { st = {}; apply(); });
    panel.addEventListener('click', function (e) {
      var b = e.target.closest('[data-k]'); if (!b) return;
      var k = b.getAttribute('data-k');
      if (k === 't') st.t = ((st.t || 0) + 1) % 3; else st[k] = !st[k];
      apply();
    });
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = panel.querySelectorAll('button'), a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    });
    document.addEventListener('click', function (e) { if (!panel.hidden && !w.contains(e.target) && !e.target.closest('[data-cm-a11y-open]')) close(); });
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cm-a11y-open]'); if (t) { e.preventDefault(); open(); }
    });
    apply();
  }
  function open() { last = document.activeElement; panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); panel.querySelector('[data-k]').focus(); }
  function close() { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); (last && last.focus ? last : btn).focus(); }
  function footerLink() {
    document.querySelectorAll('footer p, footer a, footer span, [class*="footer"] p').forEach(function (n) {
      if (n.children.length === 0 && /^\s*(Accesibilidad|Accessibility)\s*$/i.test(n.textContent)) {
        var el = n.closest('a') || n; el.setAttribute('data-cm-a11y-open', ''); el.setAttribute('role', 'button'); el.setAttribute('tabindex', '0'); el.style.cursor = 'pointer';
        el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
      }
    });
  }
  apply();
  function init() { build(); footerLink(); reposition(); window.addEventListener('scroll', schedule, { passive: true }); window.addEventListener('resize', schedule); setInterval(reposition, 1500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
